import { useResponsive } from '@shared/utils/hooks/useResponsive';

export interface AccommodationsListingMobileLayoutState
  extends Readonly<{
    // True when screen < 768px (sm2 breakpoint). Matches the listing container's
    // flexDirection switch so JS layout predicates and CSS breakpoints stay aligned.
    isMobileOrTablet: boolean;
    shouldUseNewMobileLayout: boolean;
  }> {}

export const useAccommodationsListingMobileLayout = (): AccommodationsListingMobileLayoutState => {
  // No explicit initialValue — SSR default is derived from the User-Agent via DefaultMediaMatchProvider
  const [isMobileOrTablet = true] = useResponsive({ values: { _: true, sm2: false } });

  // The V2 tap-anywhere card is the only mobile layout now, so mobile widths always get it.
  const shouldUseNewMobileLayout = isMobileOrTablet;

  return {
    isMobileOrTablet,
    shouldUseNewMobileLayout,
  };
};
